import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  dotType: PropTypes.oneOf(['horizontal', 'vertical']),
};

const DotTrigger = ({
  className,
  active,
  dotType = 'horizontal',
  ...props
}) => {
  const classes = classNames({
    'dot-trigger-btn': dotType === 'horizontal',
    'dot-trigger-btn-vertical': dotType === 'vertical',
    'is-active': active,
    [className]: !!className,
  });

  const spanClasses = classNames({
    'dot-trigger-btn-dots': dotType === 'horizontal',
    'vertical-dot-trigger-btn-dots': dotType === 'vertical',
  });

  return (
    <button className={classes} {...props}>
      <span className={spanClasses} />
    </button>
  );
};

DotTrigger.propTypes = propTypes;

export default DotTrigger;
